'use strict';

export default function TimerWidget({ seconds, showUnits = false, onExpire = undefined, expiredText = undefined }) {
    
    const [secondsLeft, setSecondsLeft] = React.useState( seconds )
    const intervalRef = React.useRef()
    
    const clearTimer = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current)
            intervalRef.current = null
        }
    }
    
    const startTimer = () => {
        if (intervalRef.current) return
        if (secondsLeft <= 0) return
        
        intervalRef.current = setInterval(() => {
            setSecondsLeft(prev => Math.max(0, prev - 1))
        }, 1000)
    }
    
    React.useEffect(() => {
        if (secondsLeft > 0) {
            startTimer()
        }
        
        return () => clearTimer()
    }, [ seconds ])

    React.useEffect(() => {
        if (intervalRef.current && secondsLeft <= 0) {
            clearTimer()
            onExpire && onExpire()
        }
    }, [secondsLeft])

    const renderTimer = React.useCallback((seconds) => {
        if (expiredText && seconds <= 0) 
            return expiredText
        
        let result = []
        const h = seconds > 0 ? Math.floor(seconds / 3600) : 0;
        const m = seconds > 0 ? Math.floor((seconds - h * 3600) / 60) : 0;
        const s = seconds > 0 ? seconds - h * 3600 - m * 60 : 0;

        if(h > 0) result.push(h < 10 ? `0${h}` : h);
        result.push(m < 10 ? `0${m}` : m);
        if (h === 0)
            result.push(s < 10 ? `0${s}` : s);

        let time = result.join(':');
        if (showUnits) {
            switch ( true ) {
                case h > 0:
                    time += ` ${tMsg('часов')}`;
                    break;
                default:
                case m > 0:
                    time += ` ${tMsg('минут')}`;
                    break;
            }
        }
        return time;
    }, [ showUnits ])

    return renderTimer(secondsLeft);
}
